import { render, staticRenderFns } from "./SharingSummaryReport.vue?vue&type=template&id=84b37d7e&scoped=true"
import script from "./SharingSummaryReport.vue?vue&type=script&lang=js"
export * from "./SharingSummaryReport.vue?vue&type=script&lang=js"
import style0 from "./SharingSummaryReport.vue?vue&type=style&index=0&id=84b37d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b37d7e",
  null
  
)

export default component.exports